import script from "./HrTextField.vue?vue&type=script&setup=true&lang=js"
export * from "./HrTextField.vue?vue&type=script&setup=true&lang=js"

import "./HrTextField.vue?vue&type=style&index=0&id=66023d6b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66023d6b"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QField});
